<template>
    <div>
        <!--    导航栏-->
<!--        <Anav></Anav>-->
        <van-nav-bar id="reset" fixed :title="$route.name"
                     style="background-color: rgba(6,193,174,1);height: 3rem" :aria-label="$route.name">
        </van-nav-bar>
        <!--    标签栏-->
        <Atablebar></Atablebar>
<!--        详情-->
        <div class="details-box" role="button" aria-labelledby="title content">
            <div class="title" id="title" aria-hidden="true">
                <div></div>
                <div>视力障碍者重疾意外险</div>
            </div>
            <div class="content" id="content" aria-hidden="true">
                <div>承保单位：<span>平安产险</span></div>
                <div>保单号码：<span>{{bxOrderNo}}</span></div>
                <div>投保人名称：<span>{{principalName}}</span></div>
                <div>投保人证件号码：<span>{{principalIdCard}}</span></div>
                <div>投保人联系电话：<span>{{principalPhone}}</span></div>
                <div>被保险人姓名：<span>{{joinName}}</span></div>
                <div>被保险人证件号码：<span>{{joinIdCard}}</span></div>
<!--                <div>保障期限：<span>1年</span></div>-->
                <div>生效日期：<span>{{effectiveDate}}</span></div>
                <div>到期日期：<span>{{deadline}}</span></div>
                <div>总保费：<span>{{amount}}</span></div>
            </div>
        </div>
    </div>

</template>

<script>

    import Vue from 'vue';
    import {Field, Button, Notify} from 'vant';
    //引入导航组件
    import Anav from './Acomponent/Anav';
    import Atablebar from './Acomponent/Atablebar';
    Vue.use(Field).use(Button).use(Notify);
    export default {
        components:{
            // Anav,
            Atablebar,
        },

        name: "Login",
        data() {
            return {
                // userBuyId:'u-1262662626011017216',

                bxOrderNo: '',//保单号
                principalName: '',//投保人姓名
                principalIdCard: '',//投保人证件号码
                principalPhone: '',//投保人电话
                joinName: '',//被保人姓名
                joinIdCard: '',//被保人证件号
                effectiveDate: '',//生效日期
                deadline: '',//到期日期
                amount: '',//总保费

            }
        },
        props: {
            name: {}
        },
        created:function(){
            this.getDetail()
        },
        methods: {
            getQueryVariable(variable){
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    if(pair[0] == variable){return pair[1];}
                }
                return(false);
            },
            getDetail(){
                var userBuyId = this.getQueryVariable('userBuyId')
                console.log(userBuyId)
                this.$axios.get("/order/detail", {params: {userBuyId:userBuyId}}).then(res => {
                    console.log(res)
                    var data = res.data

                    this.bxOrderNo = data.detail.bxOrderNo
                    this.principalName = data.detail.principalName
                    this.principalIdCard = data.detail.principalIdCard
                    this.principalPhone = data.detail.principalPhone
                    this.joinName = data.userBuy.joinName
                    this.joinIdCard = data.userBuy.joinIdCard
                    this.effectiveDate = data.detail.effectiveDate
                    this.deadline = data.detail.deadline
                    this.amount = data.detail.amount/100

                });
            }
        }
    }
</script>

<style scoped>
    #reset /deep/ .van-ellipsis{
        color: #fff !important;
        font-size:1.2rem;
        font-weight:500;
    }
    .details-box{
        width: 92%;
        background-color: #fff;
        margin: 82px auto 0;
        color: #666;
        font-size: 1rem;
        border-radius: 12px;
    }
    .details-box .title{
        height: 64px;
        color: rgba(51,51,51,1);
        font-size: 1.2rem;
        font-weight: bold;
        line-height: 63px;
        display: flex;
        border-bottom: 1px solid #eee;

    }
    .details-box .title div:first-child{
        width: 4px;
        height: 20px;
        background-color: rgb(6, 193, 174);
        margin: 22px 16px 0 22px;
    }
    .details-box .content{
        padding: 8px 20px 30px 20px;
        line-height: 2rem;
    }
</style>
